export const extractPathSegments = (pathname: string) => {
  return pathname.split('/').filter((item) => item !== '');
};
